export enum AdditionalFieldEntityType {
  LineItem = 1,
  Modification = 2,
}

export enum AdditionalFieldType {
  Variable = 1,
  Attachment = 2,
}
